import React from "react";
import "./product-card.scss";
import BrandLogo from "../../../images/kikoimg.svg";
import { MinusIcon, PlusIcon } from "../../svgicons";
import { formatAndLocalizeText } from "../utils";
import LoaderWhite from "../LoaderWhite";

const ProductCard = ({ navigate, data, catalogDataTemp, setVariant, updateCartItemQuantity, cartItems, onPressCard, onPressMinus, onPressPlus, onPressAddToCart, selectLoading, selectLoadingId }) => {
  return (
    <>
      <div className="product-card-kl" onClick={() => {
        if (typeof onPressCard === "function") {
          onPressCard()
        }
        else {
          const encodedPId = encodeURIComponent(data?.providerId);
          const encodedPCode = encodeURIComponent(data?._id);
          navigate(`/product-details?providerId=${encodedPId}&productCode=${encodedPCode}`, {
            state: {
              catalogDataArray: catalogDataTemp,
            },
          })
        }
      }}>
        <div className="product-card-header-kl">
          <div className="product-card-img-kl">
            <img src={data?.productImages?.[0]}
              alt="productImages"
              onError={(event) => {
                event.target.onerror = null;
                event.target.src = BrandLogo;
                event.target.classList.add("default-img");
              }} />
          </div>
        </div>
        <div className="product-card-body-kl">
          <div>
            <div className="product-card-title-kl">
              {data?.productName ?? ""}
            </div>
            {data?.variants?.length > 1 ?
              (
                <select
                  className="form-select weight-select-kl"
                  aria-label="Default select example"
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => setVariant(e.target.value, data)}
                >
                  {data?.variants?.map((variant, index) => (
                    <option value={variant?._id} key={index}>
                      {`${variant?.weightUnit === "unit" && !variant?.weight
                        ? "1"
                        : variant?.weight
                        } ${formatAndLocalizeText(variant?.weightUnit)}`}
                    </option>
                  ))}
                </select>
              ) :
              <div className="weight-select-kl">
                {`${data?.variants?.[0]?.weightUnit ===
                  "unit" && !data?.variants?.[0]?.weight
                  ? "1"
                  : data?.variants?.[0]?.weight
                  } ${formatAndLocalizeText(
                    data?.variants?.[0]?.weightUnit
                  )}`}
              </div>
            }
            <div className="product-card-price-kl">
              ₹{data?.price}
              {data?.maximumPrice && (parseFloat(data?.maximumPrice) !== parseFloat(data?.price)) && (
                <span className="line-through">
                  ₹{data?.maximumPrice}
                </span>
              )}
            </div>
          </div>
          <div className="add-cart-btn-container" onClick={(e) => e.stopPropagation()}>
            {cartItems.some((item) => item._id === data._id) ?
              (
                <div id={`ui${data._id}`} className="add-to-cart-qty-container-kl">
                  <div
                    className="add-to-cart-button-kl add-to-cart-minus-btn"
                    onClick={() => {
                      if (typeof onPressMinus === "function") {
                        onPressMinus()
                      }
                      else {
                        updateCartItemQuantity(
                          data._id,
                          data.quantity <= 1 ? 0 : data.quantity - 1,
                          data
                        )
                      }
                    }}
                  >
                    <MinusIcon />
                  </div>
                  <div className="add-to-cart-input-kl">{data?.quantity ?? 0}</div>
                  <div
                    className="add-to-cart-button-kl add-to-cart-plus-btn"
                    onClick={() => {
                      if (typeof onPressPlus === "function") {
                        onPressPlus()
                      }
                      else {
                        updateCartItemQuantity(data._id, data.quantity + 1, data)
                      }
                    }}
                  >
                    <PlusIcon />
                  </div>
                </div>
              ) :
              (
                <button
                  type="button"
                  id={data._id}
                  className="add-btn-kl"
                  disabled={selectLoading}
                  onClick={() => {
                    if (onPressAddToCart) {
                      onPressAddToCart()
                    }
                    else {
                      updateCartItemQuantity(data._id, 1, data, true);
                    }
                  }}
                >
                  <div className="dotLoader">{selectLoading && selectLoadingId === data._id ? <LoaderWhite /> : <PlusIcon />}</div>
                </button>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
